import request from '@/utils/request'

export function pageChange(query) {
  return request({
    url: '/biz/user-change/page',
    method: 'get',
    params: query
  })
}